import { List } from 'immutable'
import { Observable } from 'rxjs'
import { RxCustomerAPI, CustomerAPI, RxGdprAPI, json } from '@driftt/dapper'
import { parseEndUser } from './models'

export const fetchNonPlaybookEvents = async orgId => {
  return CustomerAPI.get(`/organizations/${orgId}/end_users/attributes2?playbookEventInclude=false`).then(
    json
  )
}

export const api = {
  fetch(id) {
    return RxCustomerAPI.get(`/end_users/${id}?withMaster=true`)
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(parseEndUser)
  },
  bulkFetch(ids) {
    return RxCustomerAPI.post(`/end_users/find`, { endUserIds: ids })
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(res => List(res).map(parseEndUser))
  },
  updateEndUser(endUserId, endUserParams) {
    return RxCustomerAPI.patch(`/end_users/${endUserId}`, endUserParams)
      .checkStatus()
      .retryWithBackoff()
  },
  fetchFollowing(id) {
    return RxCustomerAPI.get(`/end_users/${id}/following`)
      .checkStatus()
      .retryWithBackoff()
      .map(({ response }) => response)
  },
  updateFollowing(id, following) {
    return RxCustomerAPI.patch(`/end_users/${id}/following`, { following })
      .checkStatus()
      .retryWithBackoff()
      .map(({ response }) => response)
  },
  updateCQL(endUserId, score, conversationId) {
    return RxCustomerAPI.post(`/end_users/${endUserId}/cql`, { conversationId, score })
      .checkStatus()
      .retryWithBackoff()
  },
  createNewContactAttribute(data) {
    return RxCustomerAPI.post('/property_definitions', data)
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  addNewContactAttribute(data) {
    return CustomerAPI.post('/property_definitions', data).then(json)
  },
  fetchUnsubscribedCount() {
    return RxCustomerAPI.get('/unsubscribe/count')
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  checkUnsubscribed(email, orgId) {
    return RxCustomerAPI.post('/unsubscribe/check', { email, orgId })
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  unsubscribe(email) {
    return RxCustomerAPI.post('/unsubscribe/mark', { email })
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  unsubscribeById({ endUserId, reason }) {
    return RxCustomerAPI.post(`/unsubscribe/enduser/${endUserId}?reason=${encodeURIComponent(reason)}`)
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  unsubscribeByEncodedEmail({ email, endUserId, reason }) {
    return RxCustomerAPI
      .post(`/unsubscribe/byIdentifier/${encodeURIComponent(window.btoa(email))}?reason=${encodeURIComponent(reason)}&endUserId=${endUserId}`)
      .retryWithBackoff(1)
      .pluck('response')
  },
  unsubscribeByEmailAndOrgId({ email, orgId }) {
    return RxCustomerAPI
      .post(`/unsubscribe/byEmail/`, {
        email,
        orgId
      })
      .retryWithBackoff(1)
      .pluck('response')
  },
  requestContactData: payload => {
    return RxGdprAPI.post('/retrieve', payload)
      .checkStatus()
      .pluck('response')
  },
  requestDataDeletion: payload => {
    return RxGdprAPI.post(`/delete`, payload)
      .checkStatus()
      .pluck('response')
  },
  requestUnsubDeleteData({ email, endUserId, orgId }) {
    return RxCustomerAPI
      .post('/unsubscribe/delete_user_data', { email, endUserId, orgId })
      .retryWithBackoff(1)
  },
  resubscribe({ email, endUserId }) {
    return RxCustomerAPI.post(`/unsubscribe/resubscribe/${encodeURIComponent(window.btoa(email))}?endUserId=${endUserId}`)
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  resubscribeByEmailandOrgId({ email, orgId }) {
    return RxCustomerAPI.post(`/unsubscribe/resubscribe`, { email, orgId })
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/api.js